/**
 * Catálogo canônico dos Lembretes e Follow-ups de Agendamento — ADR-150
 * (fontes `appointment_reminder`/`appointment_followup` da ADR-104, sobre o
 * motor SOA da ADR-149).
 *
 * Fonte da verdade triangulada (R15):
 * - **Offsets por pacote**: ADR-115 D115.3 (`appointment-reminder-policy`) —
 *   Solo/Team D-1; Professional D-3 + D-1; Regulated D-7 + D-3 + D-1 + 2h.
 * - **Opt-in** (P12 — proatividade configurável): `Tenant.
 *   appointmentReminderPolicy` null ou `enabled !== true` ⇒ zero disparo
 *   (cenário inalterado — nenhum tenant muda de conduta no deploy).
 * - **Modo default H_b** (ADR-150 D6): confirmação de presença via mensagem
 *   ainda não transiciona o Appointment (`confirmed` automático = futuro
 *   D115.4); a IA envia e para — a resposta cai no inbox.
 *
 * Mudança de semântica (offset novo, default) = via humano + incremento de
 * `APPOINTMENT_REMINDERS_CATALOG_VERSION` (molde ADR-148/149).
 */
export const APPOINTMENT_REMINDERS_CATALOG_VERSION = 1;
/** Antecedências canônicas (horas antes do `scheduledAt`) — ADR-115 D115.3. */
export const REMINDER_OFFSET_HOURS_OPTIONS = [168, 72, 24, 2];
/** Defaults de offsets por pacote quando `enabled` sem `reminderOffsetsHours` (ADR-115 D115.3). */
export const REMINDER_OFFSETS_BY_PACKAGE = {
    solo: [24],
    team: [24],
    professional: [72, 24],
    regulated: [168, 72, 24, 2],
};
/** Opções canônicas de atraso do follow-up pós-`completed` (horas). */
export const FOLLOWUP_DELAY_HOURS_OPTIONS = [4, 24, 48];
export const DEFAULT_FOLLOWUP_DELAY_HOURS = 24;
/**
 * Modo de operação da conversa proativa do lembrete/follow-up (ADR-030):
 *   - `H_b` (default) — IA envia e para; resposta do cliente cai no inbox.
 *   - `H_c` — conductor conduz a resposta COM os Gatilhos de Proteção (ADR-148).
 *   - `H_a` — sistema NÃO envia nada; cria Pendency para o atendente disparar.
 */
export const APPOINTMENT_REMINDER_MODES = ['H_a', 'H_b', 'H_c'];
export const DEFAULT_APPOINTMENT_REMINDER_MODE = 'H_b';
//# sourceMappingURL=catalog.js.map